export default {
    setSelectedAlbum(state, value) {
        state.selectedAlbum = value
    },
};
